<template>
  <div>
    <div class="d-flex">
      <div class="side-frame-success"></div>
      <div>
        <span style="font-size: 14px; color: #606266">
          Platform No：{{ formData.platformNo ? formData.platformNo : 'New' }}
        </span>
        <el-divider direction="vertical"></el-divider>
        <b-badge
          style="font-size: 12px"
          :variant="
            formData.platformStatus === 'Y'
              ? 'success'
              : formData.platformStatus === 'N'
              ? 'danger'
              : 'primary'
          "
        >
          {{ formData.v_platformStatus }}
        </b-badge>
        <el-divider direction="vertical"></el-divider>
        <span style="font-size: 14px; color: #606266">
          Update：{{ formData.modifyByName ? formData.modifyByName : '--' }} at
          {{ formData.modifyDate ? formData.modifyDate : '--' }}
        </span>
      </div>
    </div>
    <el-form
      ref="form"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
      size="small"
    >
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_platformName') || '电商平台名称'"
            prop="platformName"
          >
            <el-input
              v-model="formData.platformName"
              clearable
              size="small"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
              maxlength="50"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_platformId') || '销售渠道ID'"
            prop="platformId"
          >
            <el-input
              v-model="formData.platformId"
              clearable
              size="small"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
              maxlength="20"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_regionName') || '所属地区名称'"
            prop="regionCode"
          >
            <dict-select
              filterable
              size="small"
              clearable
              v-model="formData.regionCode"
              :selectedLabel.sync="formData.regionName"
              :body="regionParams"
              url="/master/common/dict/biz"
              :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_ecomCompanyName') || '申请公司'"
            prop="ecomCompanyCode"
          >
            <dict-select
              size="small"
              clearable
              filterable
              v-model="formData.ecomCompanyCode"
              url="/ecom/ecomCompany/select"
            ></dict-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_platformType') || '渠道类型'"
            prop="platformType"
          >
            <dict-select
              filterable
              size="small"
              clearable
              v-model="formData.platformType"
              :body="platformTypeParams"
              url="/sys/common/dict/system"
              :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_custCode') || '所属客户'"
            prop="custCode"
          >
            <dict-select
              v-model="formData.custCode"
              url="/master/common/dict/customerSelect"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              size="small"
              clearable
              filterable
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_ecomPmaCode') || '电商平台账户'"
            prop="ecomPmaCode"
          >
            <dict-select
              filterable
              size="small"
              clearable
              v-model="formData.ecomPmaCode"
              :body="ecomPmaCodeParams"
              url="/ecom/evg/platform/select/account"
              :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_warehousePmaCode') || '仓库平台账户'"
            prop="warehousePmaCode"
          >
            <dict-select
              filterable
              size="small"
              clearable
              v-model="formData.warehousePmaCode"
              :body="warehousePmaCodeParams"
              url="/ecom/evg/platform/select/account"
              :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
            ></dict-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
         <el-col :span="8">
          <el-form-item
            :label="$l('form_label_shippingMethod') || '发运方式'"
            prop="shippingMethod"
          >
            <el-input
              v-model="formData.shippingMethod"
              clearable
              size="small"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
              maxlength="100"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="$l('form_label_warehouseCode') || '仓库代码'"
            prop="warehouseCode"
          >
            <el-input
              v-model="formData.warehouseCode"
              clearable
              size="small"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
              maxlength="100"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="$l('form_label_shipNode') || '分销商ID'"
            prop="shipNode"
          >
            <el-input
              v-model="formData.shipNode"
              clearable
              size="small"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
              maxlength="100"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item :label="$l('form_label_remark') || '备注说明'">
            <el-input
              type="textarea"
              v-model="formData.remark"
              clearable
              size="small"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
              rows="3"
              maxlength="1000"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  props: {
    platformCode: { type: String, default: '' },
    disabled: { type: Boolean, default: true },
  },
  data() {
    return {
      regionParams: { dictType: 'region' },
      platformTypeParams: { dictType: 'platformType' },
      ecomPmaCodeParams: {'platformType': 'E'},
      warehousePmaCodeParams: {'platformType': 'W'},
      formData: {},
      rules: {
        platformName: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
        platformId: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
        regionCode: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
        platformType: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
        custCode: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
      },
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    ...mapActions('admin/page', ['close']),
    getData() {
      if (!this.platformCode) return
      this.$api
        .ecomHxPlatformDetailApi({
          platformCode: this.platformCode,
        })
        .then((res) => {
          this.formData = res.body
        })
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return

      this.loadingOpen()

      this.$api
        .ecomHxPlatformSaveApi(this.formData)
        .then(async (res) => {
          this.loadingClose()
          const { status } = res
          if (status !== 200) {
            this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
            return
          }
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_save_ok') || '保存成功！',
            type: 'success',
          })
          if (!this.platformCode) {
            this.closeCurPage()
          } else {
            this.getData()
          }
        })
        .catch(() => {
          this.loadingClose()
          this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        })
    },
    async closeCurPage() {
      // 关闭当前页面
      await this.close({
        tagName: this.$route.fullPath,
        showConfirm: false,
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame-success {
  padding: 1px 5px;
  border-left: 3px solid $color-success;
  height: 20px;
  margin-top: 3px;
}
.side-frame-warning {
  padding: 1px 5px;
  border-left: 3px solid $color-warning;
  height: 20px;
  margin-top: 3px;
}
</style>
